import * as React from 'react';
import { useTheme } from '../../../../../theme';
import { Tooltip } from '../../../../../BaseComponents';
import { CdnIcon } from '@shared/ui';
import { TaxesDetails } from '../TaxesDetails';
import cn from 'classnames';
import { useShowTaxesInfo } from '../../../../../hooks';
const TaxesTooltip = ({ className, children, taxesDetails }) => {
    const { TaxesTooltip: theme } = useTheme('Entities').Fare;
    const showTaxesInfo = useShowTaxesInfo();
    const content = taxesDetails.passengerFares.length > 0 && React.createElement(TaxesDetails, Object.assign({}, taxesDetails));
    if (!showTaxesInfo || !content) {
        return null;
    }
    return (React.createElement("span", { className: cn(theme.root, className) },
        React.createElement(Tooltip, { title: content, placement: "bottom-end", enterTouchDelay: 0, PopperProps: {
                modifiers: [
                    { name: 'flip', enabled: true },
                    { name: 'preventOverflow', enabled: true }
                ]
            } }, children !== null && children !== void 0 ? children : (React.createElement("div", { className: theme.price__iconWrapper },
            React.createElement(CdnIcon, { className: theme.price__icon, icon: "Info/Details" }))))));
};
export default TaxesTooltip;
